// Domain types and rules shared by the API, workers, web and mobile.
// Keep framework code (Fastify, React) out of this package.
/** Canadian provinces and territories we operate in, by ISO 3166-2 subdivision code. */
export const PROVINCES = ['NL', 'ON'];
export * from './access.js';
export * from './settings.js';
export * from './locale.js';
//# sourceMappingURL=index.js.map